import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    LoanBenefitGroupDto, LoanBenefitGroupPaginator,
    CreateLoanBenefitGroupDto,
    QueryLoanBenefitGroupDto,
    SearchLoanBenefitGroupDto,
    UpdateLoanBenefitGroupDto
} from "../models/loan-benefit-group.dto";
import ENDPOINTS from "./utils/endpoints";
import {QueryOptionsDto} from "../models/generic.dto";

export function useGetLoanBenefitGroup(companyId: number, options?: QueryLoanBenefitGroupDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.LOANBENEFITGROUP.GET;
    const request = (options: QueryLoanBenefitGroupDto) => API.ProcessingCompanyAPI.getLoanBenefitGroups(companyId,options);

    const { data, isLoading, error, refetch } = useQuery<LoanBenefitGroupPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetLoanBenefitGroupSearch(companyId: number) {

    return useMutation(
        (options?: SearchLoanBenefitGroupDto) => API.ProcessingCompanyAPI.getLoanBenefitGroupSearch(companyId, options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetLoanBenefitGroupById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.LOANBENEFITGROUP.DETAIL;
    const request = API.ProcessingCompanyAPI.getLoanBenefitGroupById(companyId,id);

    const {data, isLoading, error} = useQuery<{ data:LoanBenefitGroupDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateLoanBenefitGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({companyId, payload}: {companyId: number, payload: CreateLoanBenefitGroupDto}) => API.ProcessingCompanyAPI.createLoanBenefitGroup(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.LOANBENEFITGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateLoanBenefitGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdateLoanBenefitGroupDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updateLoanBenefitGroup(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.LOANBENEFITGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteLoanBenefitGroup() {

    return useMutation(
        ({companyId, id}: {companyId: number, id: number}) => API.ProcessingCompanyAPI.deleteLoanBenefitGroupById(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}